var moduleMap = {
	".": () => {
		return Promise.all([__webpack_require__.e(343), __webpack_require__.e(198), __webpack_require__.e(735), __webpack_require__.e(282), __webpack_require__.e(640), __webpack_require__.e(861), __webpack_require__.e(987), __webpack_require__.e(24), __webpack_require__.e(347), __webpack_require__.e(666), __webpack_require__.e(428), __webpack_require__.e(203), __webpack_require__.e(790), __webpack_require__.e(291), __webpack_require__.e(250), __webpack_require__.e(148), __webpack_require__.e(62), __webpack_require__.e(702), __webpack_require__.e(438), __webpack_require__.e(404), __webpack_require__.e(287), __webpack_require__.e(461), __webpack_require__.e(134), __webpack_require__.e(526), __webpack_require__.e(519), __webpack_require__.e(325), __webpack_require__.e(754), __webpack_require__.e(661), __webpack_require__.e(847), __webpack_require__.e(603), __webpack_require__.e(306), __webpack_require__.e(491), __webpack_require__.e(414), __webpack_require__.e(824), __webpack_require__.e(771), __webpack_require__.e(352), __webpack_require__.e(141), __webpack_require__.e(786), __webpack_require__.e(317)]).then(() => (() => ((__webpack_require__(28317)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});